import React from "react";
import {
  Calendar as CalendarIcon,
  TrendingUp,
  CheckCircle,
  AlertCircle,
  Users,
} from "lucide-react";
import SharedStatsGrid from "../../../../components/StatsGrid";
import { getResponsiveStyles } from "../../../../utils/styleUtils";

// Thin adapter over the app-wide StatsGrid (src/components/StatsGrid.jsx) so
// the Calendar's stat cards share the exact design used by Dashboard /
// Employee Management. Only the data (labels, values, icons, colors) is
// page-specific.
const StatsGrid = ({ calendarStats, screenSize, language, theme, t }) => {
  const styles = getResponsiveStyles(screenSize, theme, language);

  const stats = [
    {
      title: t.totalEvents,
      value: calendarStats.totalEvents,
      icon: CalendarIcon,
      iconBackground: "#2e7cba",
      showSymbol: true,
      valueAlign: 50,
    },
    {
      title: t.thisMonth,
      value: calendarStats.thisMonth,
      icon: TrendingUp,
      iconBackground: "#2e7cba",
      showSymbol: true,
      valueAlign: 50,
    },
    {
      title: t.completed,
      value: calendarStats.completed,
      icon: CheckCircle,
      iconBackground: "#84cc16",
      showSymbol: true,
      valueAlign: 50,
    },
    {
      title: t.overdue,
      value: calendarStats.overdueEvents,
      icon: AlertCircle,
      iconBackground: "#ef4444",
      showSymbol: true,
      valueAlign: 50,
    },
    {
      title: t.meetings,
      value: calendarStats.meetings,
      icon: Users,
      iconBackground: "#ec4899",
      showSymbol: true,
      valueAlign: 50,
    },
  ];

  return (
    <SharedStatsGrid
      styles={styles}
      stats={stats}
      screenSize={screenSize}
      gridStyle={{
        // Fluid 5-up row on desktop, wraps on tablets/phones — same grid the
        // Employee Management pages use for their five stat cards.
        gridTemplateColumns: "repeat(auto-fit, minmax(min(150px, 100%), 1fr))",
      }}
    />
  );
};

export default StatsGrid;
